;(function( window, document, bq ){ window.jQuery(function($) { 'use strict';

bq.groupRecommendations = function(element, options) {
    this.$el      = $(element);
    this.options  = $.extend({}, bq.groupRecommendations.DEFAULTS, this.$el.data(), options);
    this._filter  = 'all';
    this._systemItems = [];
    this._orgItems    = [];
    this._isLoading   = false;
    this._editItem    = null;
    this.init();
};

bq.groupRecommendations.DEFAULTS = {
    logUrl:                      '',
    combinedUrl:                 '',
    updateRecommendationStatusUrl: '',
    writeQuantityUrl:            '',
    supplierImageBaseUrl:        '',
    labels: {
        noRecommendations:      'No recommendations found.',
        loadFailed:             'Failed to load recommendations.',
        missingSupplierId:      'Missing supplier_id or sku in recommendation data.',
        noChanges:              'No changes detected. Please modify the quantity.',
        invalidQty:             'Please enter a valid quantity (must be at least 1).',
        updateSuccess:          'Forecast updated successfully!',
        updateFailed:           'Failed to update forecast',
        statusUpdateFailed:     'Failed to update forecast status.',
        externalIdNotFound:     'Forecast external ID not found.',
        removing:               'Removing...',
        removed:                'Removed',
        remove:                 'Remove',
        save:                   'Save',
        saving:                 'Saving...',
        edit:                   'Edit',
        disable:                'Disable',
        enable:                 'Enable'
    }
};

bq.groupRecommendations.prototype = {
    _isNewDesign: function() {
        return typeof bq.getIsThemeNew === 'function'
            ? bq.getIsThemeNew()
            : $('body').is('.theme-new, .light-theme, .dark-theme');
    },

    _tbody: function() {
        return $('#bq-recs-selected tbody').first();
    },

    _statusCell: function(selector) {
        var $status = $(selector);
        return $status.is('tr') ? $status.find('td').first() : $status;
    },

    _clearRows: function() {
        this._tbody().find('.bq-rec-row, .bq-rec-empty-row').remove();
    },

    _showPageLoading: function() {
        var message = (bq.messages && bq.messages.global && (bq.messages.global.loadingLongWait || bq.messages.global.loadingGeneral)) || 'Please wait...';
        var $body = $('body');

        if (typeof $.fn.viewHandler === 'function' && !$body.data('bq.viewHandler')) {
            $body.viewHandler($body.data());
        }

        bq.helper.throwEvent('bq.viewhandler.progressmessage', $body, { message: message });
    },

    _hidePageLoading: function() {
        bq.helper.throwEvent('bq.viewhandler.stop', $('body'));
    },

    _renderEditAction: function(rowId, labels, isNewDesign) {
        if (!isNewDesign) {
            return '<button type="button" class="btn btn-xs btn-primary bq-edit-rec-btn rec-btn-mr" data-row-id="' + rowId + '">' + labels.edit + '</button>';
        }

        return '<a href="javascript:void(0);" class="action-icon-circle edit bq-edit-rec-btn rec-btn-mr" data-row-id="' + rowId + '" aria-label="' + labels.edit + '" data-toggle="tooltip" data-container="body" data-placement="left" title="' + labels.edit + '">' +
            '<span class="fa fa-pencil" aria-hidden="true"></span>' +
            '</a>';
    },

    _renderRemoveAction: function(rowId, labels, isNewDesign) {
        if (!isNewDesign) {
            return '<button type="button" class="btn btn-xs btn-danger" data-action="remove" data-id="' + rowId + '" data-source="org">' + labels.remove + '</button>';
        }

        return '<a href="javascript:void(0);" class="action-icon-circle delete bq-remove-rec-btn" data-remove-row-id="' + rowId + '" aria-label="' + labels.remove + '" data-toggle="tooltip" data-container="body" data-placement="left" title="' + labels.remove + '"' +
            ' data-bq="confirm-dialog" data-title="' + bq.messages.global.dialogConfirmTitle + '"' +
            ' data-message="Are you sure you want to remove this product?"' +
            ' data-yes="Yes" data-no="No" data-wait="false"' +
            ' data-action-onclick="javascript: bq.groupRecommendationsConfirmRemove(\'' + rowId + '\');">' +
            '<span class="fa fa-trash-o" aria-hidden="true"></span>' +
            '</a>';
    },

    _handleConfirmedRemove: function(rowId) {
        var $btn = $('#bq-recs-selected [data-remove-row-id="' + rowId + '"]').first();
        if ($btn.length) {
            this._handleRemove($btn, true);
        }
    },

    init: function() {
        var self = this;
        window.loadRecommendations = function() { self._loadRecommendations(); };
        bq.groupRecommendationsConfirmRemove = function(rowId) { self._handleConfirmedRemove(rowId); };
        this._bindEvents();
        this._loadIfVisible();
    },

    _defaultImageUrl: function() {
        return this.options.supplierImageBaseUrl + 'placeholder.jpg';
    },

    _imageHtml: function(imageUrl, supplierId, size) {
        return bq.recommendations.buildImageHtml(imageUrl, supplierId, this.options.supplierImageBaseUrl, this._defaultImageUrl(), size);
    },

    _contentGroupId: function() {
        return $('#bq-recs-content-group').val();
    },

    _splitBySource: function(forecasts) {
        var system = [], org = [];
        $.each(forecasts || [], function(_, item) {
            if (item.system === true || item.system === 1 || item.system === 'true') {
                var s = $.extend({}, item); s.recommendation_source = 'SYS'; system.push(s);
            }
            if (item.org === true || item.org === 1 || item.org === 'true') {
                var o = $.extend({}, item); o.recommendation_source = 'ORG'; org.push(o);
            }
        });
        return { system: system, org: org };
    },

    _sortAndFilter: function(filter) {
        var items = [], self = this;
        if (filter === 'all') {
            var map = {};
            $.each(this._systemItems, function(_, item) {
                var key = String(item.supplier_id || '') + '|' + String(item.sku || item.supplier_sku || '');
                if (!map[key]) { map[key] = $.extend({}, item); map[key].recommendation_source = 'SYS'; }
            });
            $.each(this._orgItems, function(_, item) {
                var key = String(item.supplier_id || '') + '|' + String(item.sku || item.supplier_sku || '');
                if (!map[key]) { map[key] = $.extend({}, item); map[key].recommendation_source = 'ORG'; }
            });
            $.each(map, function(_, item) { items.push(item); });
            items.sort(function(a, b) {
                if (a.recommendation_source === 'SYS' && b.recommendation_source !== 'SYS') return -1;
                if (a.recommendation_source !== 'SYS' && b.recommendation_source === 'SYS') return 1;
                if (a.recommendation_source === 'SYS') {
                    return (a.recommendation_rank !== undefined ? a.recommendation_rank : 999999) -
                           (b.recommendation_rank !== undefined ? b.recommendation_rank : 999999);
                }
                return 0;
            });
        } else if (filter === 'system') {
            items = this._systemItems.slice().sort(function(a, b) {
                return (a.recommendation_rank !== undefined ? a.recommendation_rank : 999999) -
                       (b.recommendation_rank !== undefined ? b.recommendation_rank : 999999);
            });
            $.each(items, function(_, item) { item.recommendation_source = 'SYS'; });
        } else if (filter === 'org') {
            items = this._orgItems.slice();
            $.each(items, function(_, item) { item.recommendation_source = 'ORG'; });
        }
        this._renderRows(items);
    },

    _renderRows: function(items) {
        var self   = this;
        var labels = bq.messages.recommendations;
        var isNewDesign = this._isNewDesign();
        var $tbody = this._tbody();
        this._clearRows();
        $('#bq-recs-loading').hide();
        $('#bq-recs-error').hide();

        if (!items || !items.length) {
            $tbody.append('<tr class="bq-rec-empty-row"><td colspan="9">' + labels.noRecommendations + '</td></tr>');
            return;
        }

        $.each(items, function(_, it) {
            var supplierId  = it.supplier_id || '';
            var sku         = it.supplier_sku || it.sku || '';
            var name        = it.name || '';
            var supplierDisplay = it.supplier_name || supplierId;
            var uom         = it.uom || '';
            var image       = self._imageHtml(it.image, supplierId, 48);
            var productId   = it.product_id || '';
            var url         = it.url || '';
            var nameCell    = url ? '<a href="' + url + '">' + name + '</a>' : name;
            var source      = it.recommendation_source || (it.system === true ? 'SYS' : 'ORG');
            var status      = it.status || 'ACTIVE';
            var qty         = it.quantity || it.qty || 1;
            var qtyType     = it.qty_type || 'SYS';
            var sysQty      = it.sys_quantity != null ? it.sys_quantity : qty;
            var orgQty      = it.org_quantity != null ? it.org_quantity : null;
            var caseSizing  = it.units_per_sku || it.case_sizing || it.quantity_multiplier || null;
            var externalIds = it.ExternalIDs || it.external_ids || (it.external_id ? [it.external_id] : []);
            var recPk       = (source === 'SYS' && it.pk) ? it.pk : (it.index || it.pk || null);
            var rowId       = 'rec-row-' + (recPk || Math.random().toString(36).substr(2, 9));
            var trId        = 'row-' + (it.product_id || rowId);

            var qtyMultDisplay = '-';
            if (caseSizing !== null && caseSizing !== undefined && caseSizing !== '') {
                var v = parseFloat(caseSizing);
                if (!isNaN(v)) { qtyMultDisplay = v % 1 === 0 ? v.toString() : v.toFixed(2).replace(/\.?0+$/, ''); }
            }

            var actionsHtml = '';
            if (source === 'ORG') {
                actionsHtml =
                    self._renderEditAction(rowId, labels, isNewDesign) +
                    self._renderRemoveAction(rowId, labels, isNewDesign);
            } else if (source === 'SYS') {
                var edText  = status === 'ACTIVE' ? labels.disable : labels.enable;
                var edClass = status === 'ACTIVE' ? 'btn-danger' : 'btn-success';
                actionsHtml =
                    self._renderEditAction(rowId, labels, isNewDesign) +
                    '<button type="button" class="btn btn-xs ' + edClass + ' bq-toggle-sys-btn" data-row-id="' + rowId + '" data-status="' + status + '">' + edText + '</button>';
            }

            var actionsCellContent = isNewDesign
                ? '<span class="bq-rec-actions-inline">' + actionsHtml + '</span>'
                : actionsHtml;

            $tbody.append(
                '<tr id="' + trId + '" class="bq-rec-row"' +
                ' data-row-id="' + rowId + '"' +
                ' data-ext-supplier="' + supplierId + '"' +
                ' data-sku="' + sku + '"' +
                ' data-source="' + source + '"' +
                ' data-status="' + status + '"' +
                ' data-product-id="' + productId + '"' +
                ' data-qty="' + qty + '"' +
                ' data-qty-type="' + qtyType + '"' +
                ' data-sys-qty="' + sysQty + '"' +
                ' data-org-qty="' + (orgQty != null ? orgQty : '') + '"' +
                ' data-case-sizing="' + (caseSizing || '') + '"' +
                ' data-pk="' + (recPk || '') + '"' +
                ' data-external-ids=\'' + JSON.stringify(externalIds) + '\'' +
                '>' +
                '<td>' + image + '</td>' +
                '<td title="' + supplierId + '">' + supplierDisplay + '</td>' +
                '<td>' + sku + '</td>' +
                '<td class="name-cell" title="' + name + '">' + nameCell + '</td>' +
                '<td>' + qty + '</td>' +
                '<td>' + qtyType + '</td>' +
                '<td>' + uom + '</td>' +
                '<td>' + qtyMultDisplay + '</td>' +
                '<td class="' + (isNewDesign ? 'text-center bq-rec-actions-cell' : 'text-right') + '">' + actionsCellContent + '</td>' +
                '</tr>'
            );
        });

        if (isNewDesign && typeof bq.confirmDialogInit === 'function') {
            bq.confirmDialogInit();
        }
    },

    _loadRecommendations: function() {
        if (this._isLoading) { return; }
        var self   = this;
        var labels = bq.messages.recommendations;
        this._isLoading = true;

        $('#bq-recs-error').hide();
        this._statusCell('#bq-recs-error').text('');
        this._clearRows();
        $('#bq-recs-loading').show();

        $.ajax({
            url:         this.options.combinedUrl,
            type:        'POST',
            dataType:    'json',
            contentType: 'application/json',
            data:        JSON.stringify({
                content_group_id: this._contentGroupId()
            })
        }).done(function(resp) {
            self._isLoading = false;
            $('#bq-recs-loading').hide();

            var hasData = resp && (resp.forecasts || resp.system_recommendations || resp.org_recommendations);
            var isOk    = resp && (resp.success === true || (resp.success === undefined && hasData));

            if (isOk || hasData) {
                if (resp.forecasts) {
                    var split = self._splitBySource(resp.forecasts);
                    self._systemItems = split.system;
                    self._orgItems    = split.org;
                } else {
                    self._systemItems = resp.system_recommendations || [];
                    self._orgItems    = resp.org_recommendations    || [];
                    $.each(self._systemItems, function(_, i) { i.recommendation_source = 'SYS'; });
                    $.each(self._orgItems,    function(_, i) { i.recommendation_source = 'ORG'; });
                }
                self._sortAndFilter(self._filter);
            } else {
                var msg = resp && resp.message ? resp.message : labels.loadFailed;
                self._statusCell('#bq-recs-error').text(msg);
                $('#bq-recs-error').show();
            }
        }).fail(function(xhr) {
            self._isLoading = false;
            $('#bq-recs-loading').hide();
            var msg = labels.loadFailed;
            if (xhr && xhr.responseJSON && xhr.responseJSON.message) { msg = xhr.responseJSON.message; }
            self._statusCell('#bq-recs-error').text(msg);
            $('#bq-recs-error').show();
        });
    },

    _openEditModal: function(item) {
        this._editItem = item;
        $('#bq-edit-rec-product-image').html(this._imageHtml(item.image, item.supplier_id, 80));
        $('#bq-edit-rec-product-name').text(item.name || '-');
        $('#bq-edit-rec-product-sku').text(item.sku || item.supplier_sku || '-');

        if (item.url) {
            $('#bq-edit-rec-product-link').attr('href', item.url).show();
        } else {
            $('#bq-edit-rec-product-link').hide();
        }

        var qtyType = item.qty_type || 'SYS';
        var sysQty  = item.sys_quantity != null ? item.sys_quantity : (item.quantity || item.qty || 1);
        var orgQty  = item.org_quantity != null ? item.org_quantity : '';

        $('#bq-edit-rec-sys-qty-display').text(sysQty);
        $('#bq-edit-rec-qty').val(orgQty).data('original-value', orgQty);
        $('input[name="bq-edit-rec-qty-type"][value="' + qtyType + '"]').prop('checked', true).data('original-value', qtyType);
        $('input[name="bq-edit-rec-qty-type"][value!="' + qtyType + '"]').prop('checked', false);
        this._applyQtyTypeUi(qtyType);
        $('#bq-edit-rec-status').hide();
        $('#bq-edit-rec-modal').modal('show');
    },

    _applyQtyTypeUi: function(qtyType) {
        if (qtyType === 'SYS') {
            $('#bq-edit-rec-qty-sys-option').css('color', '');
            $('#bq-edit-rec-qty-org-option').css('color', '#999');
            $('#bq-edit-rec-qty').prop('disabled', true);
        } else {
            $('#bq-edit-rec-qty-org-option').css('color', '');
            $('#bq-edit-rec-qty-sys-option').css('color', '#999');
            $('#bq-edit-rec-qty').prop('disabled', false);
        }
    },

    _handleSave: function() {
        var self   = this;
        var labels = bq.messages.recommendations;
        if (!this._editItem) { return; }

        var $btn    = $('#bq-edit-rec-save-btn');
        var $status = $('#bq-edit-rec-status');

        $btn.prop('disabled', true).text(labels.saving);
        $status.hide();

        var item           = this._editItem;
        var supplierId     = item.supplier_id;
        var sku            = item.sku || item.supplier_sku;
        var rawSource      = item.recommendation_source || (item.source === 'system' ? 'SYS' : 'ORG');
        var source         = rawSource === 'SYS' ? 'MNG_SYS' : 'MNG_ORG';
        var productId      = item.product_id;
        var contentGroupId = this._contentGroupId();

        if (!supplierId || !sku) {
            $status.removeClass('alert-success alert-danger alert-warning').addClass('alert-danger').text(labels.missingSupplierId).show();
            $btn.prop('disabled', false).text(labels.save);
            return;
        }

        var $checkedRadio  = $('input[name="bq-edit-rec-qty-type"]:checked');
        var qtyType        = $checkedRadio.val() || 'SYS';
        var originalQtyType = $('input[name="bq-edit-rec-qty-type"][value="' + (item.qty_type || 'SYS') + '"]').data('original-value') || item.qty_type || 'SYS';
        var qtyTypeChanged = qtyType !== originalQtyType;

        var $qtyInput   = $('#bq-edit-rec-qty');
        var currentQty  = $qtyInput.val().trim();
        var originalQty = $qtyInput.data('original-value');
        var qtyChanged  = qtyType === 'ORG' && currentQty !== '' && parseFloat(currentQty) !== parseFloat(originalQty);

        if (!qtyTypeChanged && !qtyChanged) {
            $status.removeClass('alert-success alert-danger alert-warning').addClass('alert-warning').text(labels.noChanges).show();
            $btn.prop('disabled', false).text(labels.save);
            return;
        }

        var payload = {
            product_id:       String(productId || ''),
            supplier_id:      String(supplierId),
            sku:              String(sku),
            source:           source,
            content_group_id: contentGroupId || '',
            qty_type:         qtyType
        };

        if (qtyType === 'ORG') {
            var qtyValue = parseFloat(currentQty);
            if (isNaN(qtyValue) || qtyValue < 1) {
                $status.removeClass('alert-success alert-danger alert-warning').addClass('alert-danger').text(labels.invalidQty).show();
                $btn.prop('disabled', false).text(labels.save);
                return;
            }
            payload.quantity = qtyValue;
        }

        $.ajax({
            url:         this.options.writeQuantityUrl,
            method:      'POST',
            dataType:    'json',
            contentType: 'application/json',
            data:        JSON.stringify(payload)
        }).done(function() {
            self._loadRecommendations();
            $status.removeClass('alert-info alert-danger alert-warning').addClass('alert-success').text(labels.updateSuccess).show();
            setTimeout(function() {
                $('#bq-edit-rec-modal').modal('hide');
                $btn.prop('disabled', false).text(labels.save);
            }, 1000);
        }).fail(function(xhr) {
            var msg = labels.updateFailed;
            if (xhr && xhr.responseJSON && xhr.responseJSON.error) { msg += ': ' + xhr.responseJSON.error; }
            $status.removeClass('alert-info alert-success alert-warning').addClass('alert-danger').text(msg).show();
            $btn.prop('disabled', false).text(labels.save);
        });
    },

    _handleToggleStatus: function($btn) {
        var self        = this;
        var labels      = bq.messages.recommendations;
        var rowId       = $btn.data('row-id');
        var $tr         = $('#bq-recs-selected tr[data-row-id="' + rowId + '"]');
        if (!$tr.length) { return; }

        var externalIds = $tr.data('external-ids') || [];
        var currentStatus = $tr.data('status');

        if (!externalIds.length) { alert(labels.externalIdNotFound); return; }

        var newStatus = currentStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
        $btn.prop('disabled', true);

        $.ajax({
            url:         this.options.updateRecommendationStatusUrl,
            type:        'POST',
            dataType:    'json',
            contentType: 'application/json',
            data:        JSON.stringify({ external_ids: externalIds, status: newStatus })
        }).done(function(resp) {
            if (resp && resp.success) {
                self._loadRecommendations();
            } else {
                $btn.prop('disabled', false);
                alert(labels.statusUpdateFailed);
            }
        }).fail(function(xhr) {
            $btn.prop('disabled', false);
            var msg = labels.statusUpdateFailed;
            if (xhr && xhr.responseJSON && xhr.responseJSON.error) { msg += ': ' + xhr.responseJSON.error; }
            alert(msg);
        });
    },

    _handleRemove: function($btn, usePageLoading) {
        var self   = this;
        var labels = bq.messages.recommendations;
        var $tr    = $btn.closest('tr');
        var supplierId  = $tr.data('ext-supplier') || '';
        var supplierSku = $tr.data('sku') || '';
        var buttonLabel = $btn.is('[data-remove-row-id]') ? '' : labels.remove;

        if (usePageLoading) {
            this._showPageLoading();
            $btn.addClass('disabled').attr('aria-disabled', 'true');
        } else {
            $btn.prop('disabled', true).text(labels.removing);
        }

        $.ajax({
            url:         this.options.logUrl,
            type:        'POST',
            dataType:    'json',
            contentType: 'application/json',
            data:        JSON.stringify({
                status:           'INACTIVE',
                supplier_id:      String(supplierId),
                sku:              String(supplierSku),
                content_group_id: this._contentGroupId() || undefined
            })
        }).done(function(resp) {
            if (resp && resp.success) {
                if (usePageLoading) {
                    self._hidePageLoading();
                } else {
                    $btn.text(labels.removed);
                }
                $tr.fadeOut(500, function() { $tr.remove(); self._loadRecommendations(); });
            } else {
                if (usePageLoading) {
                    self._hidePageLoading();
                    $btn.removeClass('disabled').removeAttr('aria-disabled');
                } else {
                    $btn.prop('disabled', false).text(buttonLabel);
                }
            }
        }).fail(function() {
            if (usePageLoading) {
                self._hidePageLoading();
                $btn.removeClass('disabled').removeAttr('aria-disabled');
                return;
            }

            $btn.prop('disabled', false).text(buttonLabel);
        });
    },

    _bindEvents: function() {
        var self = this;

        this.$el.on('click.groupRecommendations', '.filter-toggle', function() {
            var $btn = $(this);
            self.$el.find('.filter-toggle').removeClass('active');
            $btn.addClass('active');
            self._filter = $btn.data('filter');
            self._sortAndFilter(self._filter);
        });

        $('#bq-recs-content-group').on('change.groupRecommendations', function() {
            self._loadRecommendations();
        });

        $('a[href="#tab-manage-recommendations"]').on('shown.bs.tab.groupRecommendations', function() {
            self._loadRecommendations();
        });

        $('#bq-recs-selected').on('click.groupRecommendations', '.bq-edit-rec-btn', function() {
            var $btn   = $(this);
            var rowId  = $btn.data('row-id');
            var $tr    = $('#bq-recs-selected tr[data-row-id="' + rowId + '"]');
            if (!$tr.length) { return; }

            var supplierId = $tr.data('ext-supplier');
            var sku        = $tr.data('sku');
            var source     = $tr.data('source');
            var pk         = $tr.data('pk');
            var item       = null;
            var pool       = source === 'ORG' ? self._orgItems : self._systemItems;

            $.each(pool, function(_, it) {
                if (pk && (it.index === pk || it.pk === pk)) { item = it; return false; }
                if (String(it.supplier_id) === String(supplierId) && String(it.sku || it.supplier_sku) === String(sku)) { item = it; return false; }
            });

            if (item) { self._openEditModal(item); }
        });

        $('#bq-edit-rec-save-btn').on('click.groupRecommendations', function() {
            self._handleSave();
        });

        $('#bq-recs-selected').on('click.groupRecommendations', '.bq-toggle-sys-btn', function() {
            self._handleToggleStatus($(this));
        });

        $('#bq-recs-selected').on('click.groupRecommendations', 'button[data-action="remove"]', function() {
            self._handleRemove($(this));
        });

        $('#bq-edit-rec-modal').on('hidden.bs.modal.groupRecommendations', function() {
            self._editItem = null;
            $('#bq-edit-rec-status').hide();
            $('#bq-edit-rec-save-btn').prop('disabled', false).text(bq.messages.recommendations.save);
        });

        $('#bq-edit-rec-modal').on('change.groupRecommendations', 'input[name="bq-edit-rec-qty-type"]', function() {
            self._applyQtyTypeUi($(this).val());
        });
    },

    _loadIfVisible: function() {
        var self = this;
        if ($('#tab-manage-recommendations').length) {
            this._loadRecommendations();
        } else {
            setTimeout(function() {
                if ($('#tab-manage-recommendations').length) { self._loadRecommendations(); }
            }, 200);
        }
    }
};

var old = $.fn.groupRecommendations;
$.fn.groupRecommendations = function(option) {
    return this.each(function() {
        var $this   = $(this);
        var data    = $this.data('bq.groupRecommendations');
        var options = typeof option === 'object' && option;
        if (!data) { $this.data('bq.groupRecommendations', new bq.groupRecommendations(this, options)); }
    });
};
$.fn.groupRecommendations.Constructor = bq.groupRecommendations;
$.fn.groupRecommendations.noConflict  = function() { $.fn.groupRecommendations = old; return this; };

bq.groupRecommendationsInit = function() {
    $('[data-bq="group-recommendations"]').each(function() {
        var $el = $(this);
        if (!$el.data('bq.groupRecommendations')) { $el.groupRecommendations(); }
    });
};
bq.init.push(bq.groupRecommendationsInit);
bq.groupRecommendationsInit();

});}( window, document, bq));
